module.exports = __webpack_public_path__ + "static/media/clipboard.2d8f2f3d.svg";